import React from "react";
import "./Section1.css";
import IRSImage from "../../../../../assets/images/irs-audit-sec1img1.png";
import IRSDots from "../../../../../assets/images/aboutus-dots.png";
const Section1 = () => {
  return (
    <div className="irs__auditsec1_section">
      <img src={IRSDots} alt="" className="irsauditsec1__section_dots" />
      <div className="irsauditsec1__section_left">
        <div className="irsauditsec1__secleft_description">
          <p>
            Nothing strikes fear in the hearts of people more than receiving an
            IRS Audit letter in the mail. Let’s be honest, no one wants to
            receive an IRS notice. We are fully qualified to present before the
            IRS and we assist clients through the entire audit process or IRS
            notices.
          </p>
          <p>
            Audits are time consuming and hence we become vital during such
            cases where our experience with tax authorities enables us to guide
            clients in their dealings with federal and state agencies. When you
            choose Serene Tax, you choose continuous commitment in keeping our
            client’s worries at bay.
          </p>
          <p>
            We are ready and willing to answer any and all questions the IRS may
            be asking of you. We handle all data review and case negotiation,
            which saves you time and money. In most cases, you’ll never need to
            communicate directly with the IRS .
          </p>
        </div>
      </div>
      <div className="irsauditsec1__section_right">
        <img src={IRSImage} alt="" className="irsauditsec1__section_img" />
      </div>
    </div>
  );
};

export default Section1;
